import { Injectable } from '@angular/core';
import { HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';
import { CrusherDataImportResult, CrusherDataPreview } from '../bo/crusher-data.models';

@Injectable({
  providedIn: 'root'
})
export class CrusherDataService {
  constructor(private readonly httpService: HttpService) {}

  previewCsv(file: File, siteId: number): Observable<HttpEvent<CrusherDataPreview>> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    return this.httpService.request('POST', `CrusherData/preview/${siteId}`, formData) as Observable<HttpEvent<CrusherDataPreview>>;
  }

  importCsv(file: File, columnsToAdd: string[], siteId: number): Observable<HttpEvent<CrusherDataImportResult>> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    formData.append('columnsToAdd', JSON.stringify(columnsToAdd));
    return this.httpService.request('POST', `CrusherData/import/${siteId}`, formData) as Observable<HttpEvent<CrusherDataImportResult>>;
  }
}
